module.exports = __webpack_public_path__ + "img/Nicotech.f9efaa84.png";